export default __webpack_public_path__ + "static/media/editBadge.6826259f.svg";